import {
  OMSMetricsRequestSchema,
  SurchargeByCategoryResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getSurchargeByCategory = {
  name: "getSurchargeByCategory" as const,
  input: OMSMetricsRequestSchema,
  output: SurchargeByCategoryResponseSchema,
};
